import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Check, DollarSign } from "lucide-react";
import { useCurrency } from "@/context/CurrencyContext";

export default function CurrencySelector({ compact = true }) {
  const { code, setCode, currencies } = useCurrency();
  const [open, setOpen] = useState(false);
  if (!currencies || currencies.length <= 1) return null;

  return (
    <div className="relative" data-testid="currency-selector">
      <button
        data-testid="currency-toggle"
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-1.5 p-2 hover:text-primary transition-colors text-sm font-mono uppercase"
        aria-label="Currency"
        aria-expanded={open}
      >
        <DollarSign className="w-4 h-4" />
        {compact ? <span>{code}</span> : <span>{currencies.find((c) => c.code === code)?.name || code}</span>}
      </button>
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 8 }}
            data-testid="currency-menu"
            className="absolute right-0 mt-2 w-56 max-h-80 overflow-y-auto bg-card border border-border shadow-2xl py-1 z-[120]"
          >
            <p className="px-4 py-2 text-[10px] font-mono uppercase tracking-widest text-muted-foreground">Prices shown in</p>
            {currencies.map((c) => (
              <button
                key={c.code}
                data-testid={`currency-${c.code}`}
                onClick={() => { setCode(c.code); setOpen(false); }}
                className={`w-full flex items-center justify-between px-4 py-2 text-sm hover:bg-secondary transition-colors ${code === c.code ? "text-primary" : "text-foreground/80"}`}
              >
                <span>{c.symbol} {c.name}</span>
                {code === c.code && <Check className="w-3.5 h-3.5" />}
              </button>
            ))}
            <p className="px-4 py-2 text-[10px] text-muted-foreground border-t border-border mt-1">Converted prices are indicative estimates, not binding quotes.</p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
